import {createBrowserHistory} from 'history';

export const inSignupSheetMaker = /^\/signup-sheet-maker\//.test(window.location.pathname);

export const history = createBrowserHistory({
  basename: inSignupSheetMaker ? '/signup-sheet-maker/' : '/signup-sheet/',
});
